<template>
  <footer class="app-footer">
    <span class="app-footer__text">{{ currentYear }} dopriorauth.com</span>
    <span class="app-footer__separator">·</span>
    <small class="app-footer__text">{{ appVersion }}</small>
    <span class="app-footer__separator">·</span>
    <a href="https://www.dopriorauth.com/company/tos" target="_blank" class="app-footer__link">Terms</a>
    <span class="app-footer__separator">·</span>
    <a href="https://www.dopriorauth.com/company/privacy" target="_blank" class="app-footer__link">Privacy</a>
  </footer>
</template>

<script setup>
const appVersion = process.env.VUE_APP_VERSION;
const currentYear = new Date().getFullYear();
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.app-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 32px;
  font-size: 12px;
  color: $lh_color_blue_gray;
  border-top: 1px solid $lh_dash_border;
}

.app-footer__separator {
  opacity: 0.4;
}

.app-footer__link {
  color: $lh_color_blue_gray;
  text-decoration: none;
  transition: color $lh_transition_fast;

  &:hover {
    color: $lh_color_navy_dark;
    text-decoration: underline;
  }
}
</style>
